import Vue, { PropType } from 'vue';

import { Eモニタリング業績予測基準値 } from '@/openapi/enum';

export default Vue.extend({
  name: 'Cモニタリング業績予測基準値Select',

  props: {
    value: {
      type: Number as PropType<Eモニタリング業績予測基準値>,
    },
  },

  data(): {
    eモニタリング業績予測基準値: typeof Eモニタリング業績予測基準値;
  } {
    return {
      eモニタリング業績予測基準値: Eモニタリング業績予測基準値,
    };
  },

  computed: {
    selected: {
      get(): number {
        return this.value;
      },
      set(v: number): void {
        this.$emit('update:value', v);
      },
    },
  },
});
